import { API_BASE_USERS, API_BASE_COMPANIES } from './constants';

const getHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
});

// 企業一覧取得
export const fetchCompanies = async () => {
  const res = await fetch(API_BASE_COMPANIES, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ action: 'list' }),
  });
  return res.json();
};

// 利用者一覧取得
export const fetchUsers = async (companyId, page, limit) => {
  const res = await fetch(API_BASE_USERS, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ action: 'list', companyId, page, limit }),
  });
  return res.json();
};

// 単体登録
export const registerUser = async (name, companyId) => {
  return fetch(API_BASE_USERS, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      action: 'register',
      name,
      role: 1,
      companyId,
    }),
  });
};

// 一括登録
export const bulkRegisterUsers = async (users, companyId) => {
  return fetch(API_BASE_USERS, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      action: 'bulk-register',
      users,
      companyId,
    }),
  });
};

// 進行操作（通常進行 or 応用選択進行）
export const advanceUserProgress = async (userId, nextCurriculum = null) => {
  return fetch(API_BASE_USERS, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      action: 'advance',
      userId,
      ...(nextCurriculum ? { nextCurriculum } : {}),
    }),
  });
};

// 状態切替（稼働 <-> 停止）
export const toggleUserStatus = async (userId, newStatus) => {
  return fetch(API_BASE_USERS, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      action: 'status',
      userId,
      status: newStatus,
    }),
  });
};

// 削除
export const deleteUser = async (userId) => {
  return fetch(API_BASE_USERS, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      action: 'delete',
      userId,
    }),
  });
};
